import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { buttonVariants } from '@fortem-monorepo/react-ui';
export const WindowTabButton = ({ windowTab, isActive = false, onTabClick, onTabClose, }) => {
    return (_jsxs("div", { className: cn(buttonVariants({ variant: 'ghost', size: 'sm' }), 'relative rounded-none border-r text-xs', {
            ['bg-white hover:bg-white font-medium']: isActive,
            ['after:absolute after:bottom-0.5 after:z-100 after:left-0 after:w-full after:bg-white after:h-[3px]']: isActive,
        }), onClick: (e) => {
            if (onTabClick) {
                onTabClick(e);
            }
        }, children: [windowTab.title, !windowTab.pinned && (_jsx("button", { className: cn(buttonVariants({ variant: 'outline' }), 'h-auto! p-1! rounded-ull'), onClick: (e) => {
                    e.stopPropagation();
                    if (onTabClose) {
                        onTabClose(e);
                    }
                }, children: _jsx(X, { className: 'size-3' }) }))] }));
};
